export const mapKey = 'LNln6dGJDxyBa7F3c7Gd'
